// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".video-swiper-titleWrap-1e94c{padding-bottom:.45rem}.video-swiper-imgCard-c8adf,.video-swiper-video-19c96{bottom:0;height:100%;left:0;position:absolute;right:0;top:0;width:100%}.video-swiper-bannerWrapper-ec683{border-radius:.36rem;overflow:hidden;position:relative;width:100%}.video-swiper-bannerWrapper-ec683:before{content:\"\";display:block;padding-top:56.25%}.video-swiper-bannerWrapper-ec683.video-swiper-regt-3c901{border-radius:0}.video-swiper-mask-c6967{background-image:linear-gradient(180deg,#000,rgba(0,0,0,.4) 98%);height:50%;width:100%;z-index:2}.video-swiper-mask-c6967,.video-swiper-playIcon-ebd31{position:absolute}.video-swiper-playIcon-ebd31{height:.86rem;left:50%;top:50%;transform:translate(-50%,-50%);width:.72rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"titleWrap": "video-swiper-titleWrap-1e94c",
	"imgCard": "video-swiper-imgCard-c8adf",
	"video": "video-swiper-video-19c96",
	"bannerWrapper": "video-swiper-bannerWrapper-ec683",
	"regt": "video-swiper-regt-3c901",
	"mask": "video-swiper-mask-c6967",
	"playIcon": "video-swiper-playIcon-ebd31"
};
export default ___CSS_LOADER_EXPORT___;
